import { mount } from 'svelte'
import './fonts.css'
import './app.css'
import App from './App.svelte'


/* Use Sentry.io for error tracking — loaded as its own dynamic chunk so the
   SDK stays out of the entry bundle. */

import { init as initTelemetry } from './helpers/telemetry.js';

initTelemetry();


/* Set up i18n */

import { addMessages, init } from 'svelte-i18n';
import en from './locale/en.json';
import nl from './locale/nl.json';

addMessages('nl', nl);
addMessages('en', en);

init({
  fallbackLocale: 'nl'
});

/* Initialize app */

const app = mount(App, {
  target: document.getElementById('app'),
})

export default app
